import styled from 'styled-components'

export const Container = styled.div.attrs({
  role: 'region',
  'aria-label': 'Upload Widget',
})`
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid ${({ theme }) => theme.Colors.forInterface.interfaceColor13};
  background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor11};
  padding-bottom: 40px;
`
